import { $subscriber, URLS } from "fire-wind-water";
import { $extras, $messageLoad } from "../../stempcore/src/core/sextra.js";
import settingPC from "@/sktempjson/template-pc.json";
import settingWAP from "@/sktempjson/template-wap.json";
import { common } from "@/model/common";
import authService from "@/services/authService";

export default {
  data() {
    return {
      extras: {},
      isSetting: URLS.getURL("isSetting") || URLS.getHash("isSetting"),
      // isInit: false,
    };
  },
  methods: {
    initConfig(init) {
      // if (process.env.NODE_ENV === "development") {
      if (this.isSetting) {
        const html = common.isMobile ? settingWAP.html : settingPC.html;
        this.extras = $extras(html).extras;
        // console.log(this.extras);
        if (init) init();
        return;
      }
      const param = {
        tenantId: common.tenantId,
        configId: common.configId,
      };
      authService.getTemplateConfig(param).subscribe((res) => {
        if (res.result == 0) {
          this.extras = $extras(res.content.info.html).extras;
          if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
            let themeColorClear = "";
            const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
            if (rgbaAttr.length >= 3) {
              let r, g, b;
              r = rgbaAttr[0];
              g = rgbaAttr[1];
              b = rgbaAttr[2];
              themeColorClear =
                "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
            }

            document.body.style.setProperty(
              "--themeColor",
              this.extras.themecolor.bgcolor
            );
            document.body.style.setProperty(
              "--themeColorClear",
              themeColorClear
            );
          }
          if (init) init();
        } else {
          window.$sk.tips.show(res.desc);
        }
      });
    },
  },
  created() {
    console.log("# subscribe 'sk-template-config'.");
    $subscriber.subscribe("sk-template-config", (o) => {
      console.log("# catch 'sk-template-config' ...");
      // console.log("# o.data: ", JSON.stringify(o.data));
      this.extras = $extras(o.data).extras;
      if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
        let themeColorClear = "";
        const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
        if (rgbaAttr.length >= 3) {
          let r, g, b;
          r = rgbaAttr[0];
          g = rgbaAttr[1];
          b = rgbaAttr[2];
          themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
        }

        document.body.style.setProperty(
          "--themeColor",
          this.extras.themecolor.bgcolor
        );
        document.body.style.setProperty("--themeColorClear", themeColorClear);
      }
    });
  },
  mounted() {
    $messageLoad(1);
  },
  beforeDestroy() {
    // this.sktemp.unsubscribe();
  },
};
